<template>
  <div space-y-4 v-if="article">
    <h2 text-2xl font-semibold text-stone-500 v-if="showTitle">About {{ title }}</h2>
    <img
      v-if="article.image"
      :src="article.image.src"
      :srcset="article.image.srcset || undefined"
      sizes="(min-width: 48rem) 48rem, 100vw"
      :width="article.image.width"
      :height="article.image.height"
      loading="lazy"
      decoding="async"
      alt=""
    />
    <div prose v-html="article.extractHtml" />
    <p>
      <Button color="light-stone" :href="article.url" icon="i-material-symbols-arrow-outward-rounded" target="_blank"
        >View on Wikipedia
      </Button>
    </p>
  </div>
</template>
<script setup>
import { decode } from "wiki-article-name-encoding";

const props = defineProps({
  slug: {
    type: String,
    required: true,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});
const title = computed(() => decode(props.slug));
// through our API: Wikipedia rejects server-side requests without a User-Agent, so this renders on the server
const { data: article } = await useLazyFetch("/api/wikipedia", {
  query: { title: computed(() => props.slug) },
});
</script>
